import Api from '@/api/finances/_api_finance.js'

export default {
    storeLigneOperation(data){
        const promise = Api().post('ligne-operations/store', data);
        return promise.then((response) => response.data)
    },

    removeAllItemsFromCaisse(data){
        const promise = Api().post('ligne-operations/delete-items', data);
        return promise.then((response) => response.data)
    },

    removeItemFromCaisse(data){
        const promise = Api().post('ligne-operations/delete/operation-attente-paiement', data);
        return promise.then((response) => response.data)
    },

    updateLigneOpOrdonnance(data){
        const promise = Api().post('ligne-operations/update-prescription', data);
        return promise.then((response) => response.data)
    },
}